// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","app__main":"App_app__main__3pRXj","overlay":"App_overlay__2FvzF"};